module.exports = __webpack_public_path__ + "img/Algeria.cdc58a3f.svg";